module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlmax/Nagano_Chlmax_GFDL_RCP26_End.png";